import { useDispatch, useSelector } from 'react-redux'
import {
  clearQuickSearch,
  updateSavedSearchFilters,
  clearSticker,
} from '../../../../store/userSearchProfile'
import { useFirefly } from '../../../../resources/useAnalytics'

export const useAppliedFilters = () => {
  const dispatch = useDispatch()
  const { handleTrackEvent } = useFirefly()

  const appliedFilters = useSelector((state) => {
    const { userSearchProfile } = state
    return userSearchProfile.savedSearch.activeSavedFilters
  }, [])
  const searchText = useSelector((state) => {
    const { userSearchProfile } = state
    const { filters } = userSearchProfile
    return filters.searchText
  }, [])
  const stickerType = useSelector((state) => {
    const { userSearchProfile } = state
    const { filters } = userSearchProfile
    return filters.stickerTypeId[0]?.values[0]?.displayValue
  }, [])
  const deleteAllFilters = (eve) => {
    eve.preventDefault()
    dispatch(updateSavedSearchFilters('all'))
    localStorage.removeItem('LP_SEARCH_CRITERIA')
    handleTrackEvent('Applied Filters', 'Clear All')
  }
  const handleDeleteQuickSearch = (eve) => {
    dispatch(clearQuickSearch([]))
    handleTrackEvent('Applied Filters', 'Clear Quick Search')
  }
  const handleDeleteSticker = (eve) => {
    dispatch(clearSticker([]))
    handleTrackEvent('Applied Filters', 'Clear Sticker')
  }

  return {
    appliedFilters,
    searchText,
    stickerType,
    deleteAllFilters,
    handleDeleteQuickSearch,
    handleDeleteSticker,
  }
}
